/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Col_NotesInputs */

const vi_warehouse_defects_col_notes = /** @type {(inputs: Warehouse_Defects_Col_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số phiếu`)
};

/**

* @param {Warehouse_Defects_Col_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_col_notes = /** @type {((inputs?: Warehouse_Defects_Col_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Col_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_col_notes(inputs)
});